<template>
  <el-dialog
      :width="this.screenWidth<768.98?'85%':'500px'"
      custom-class="pc-setLang"
      append-to-body
      :show-close="false"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
    <div slot="title">
      <!-- 设置您的偏好-->
      <div class="h-title">{{$t('footer.setpreferences')}}</div>
      <!-- 请设置您的语言-->
      <div class="h-text">{{$t('footer.setlanguage')}}</div>
    </div>
    <el-form :model="dataForm" class="content" label-position="top">
      <!-- 语言-->
      <el-form-item :label="$t('footer.language')" prop="languageCode" class="mb-0">
        <el-select
            v-model="dataForm.languageCode"
            placeholder="">
          <el-option
              v-for="(item,index) in $g.languageList"
              :key="index"
              :label=item.name
              :value=item.code>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- 取消-->
      <el-button @click="closeDialog">{{$t('friends.cancel')}}</el-button>
      <!-- 确认-->
      <el-button type="primary" @click="confirm">{{$t('luckdraw.comfirm')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Bus from "@/util/Bus";
import PubSub from "pubsub-js";
export default {
  name: "setLang",
  data(){
    return{
      screenWidth:null,
      dialogFormVisible:false,
      dataForm:{
        languageCode:''
      }

    }
  },
  methods:{
    init(){
      this.dialogFormVisible = true;
    },
    confirm(){
      Bus.$emit('switchLanguage', this.dataForm.languageCode);
      PubSub.publish('changeLanguage', this.dataForm.languageCode);
      this.$emit('refresh');
      this.closeDialog();
    },
    closeDialog(){
      this.dialogFormVisible = false;
      setTimeout(()=>{
        this.dataForm.languageCode = localStorage.lang;
      },400)
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },

  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
    this.dataForm.languageCode = localStorage.lang;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog.pc-setLang{
  border-radius: 10px;
  margin-top:0!important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .el-dialog__title{
    font-weight:700;
    font-size: 20px;
    @media(max-width:575.98px){
      font-size: 16px;
    }
  }

  .el-button{
    font-size:14px;
    padding: 20px 40px !important;
    border-radius: 34px !important;
    width: calc(100% / 2 - 20px);
    @media(max-width:575.98px){
      padding:10px 40px!important;
    }
  }
  .h-title{
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom:16px;
  }
  .h-text{
    color: #a3a2a2;
  }
  .el-dialog__header{
    padding-bottom:24px;
    border: 1px solid #f5f2f2;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .el-dialog__body{
    padding: 24px 18px 24px 24px;
    border: 1px solid #f5f2f2;
  }
  .el-dialog__footer{
    padding: 24px;
    text-align: left!important;
  }
}
.dialog-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>